import { gql } from '@apollo/client';

// GraphQL query to get presigned URL for CPSC citation codes JSON file.
// codeType: 'INCLUSION' for testingInclusions (ITL/LAB) or 'EXCLUSION' for testingExclusions (NOL)
// Returns: Presigned S3 URL, codeType, and expiration time in seconds
export const GET_CPSC_CITATION_CODES_PRESIGNED_URL = gql`
  query GetCpscCitationCodesPresignedUrl($codeType: CpscCitationCodeType!) {
    getCpscCitationCodesPresignedUrl(codeType: $codeType) {
      url
      codeType
      expiresIn
    }
  }
`;
